import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

export function useNativeFeatures() {
  const [isNative, setIsNative] = useState<boolean>(false);
  const [platform, setPlatform] = useState<'ios' | 'android' | 'web'>('web');

  useEffect(() => {
    const checkPlatform = () => {
      // Check if running in native environment
      const isNative = Capacitor.isNativePlatform();
      setIsNative(isNative);
      
      // Determine platform
      if (isNative) {
        if (Capacitor.getPlatform() === 'ios') {
          setPlatform('ios');
        } else if (Capacitor.getPlatform() === 'android') {
          setPlatform('android');
        }
      }
    };
    
    checkPlatform();
  }, []);

  return {
    isNative,
    platform,
    isIOS: platform === 'ios',
    isAndroid: platform === 'android',
    isWeb: platform === 'web'
  };
}

export function useSafeArea() {
  const [safeArea, setSafeArea] = useState({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  });

  useEffect(() => {
    const updateSafeArea = () => {
      if (window.document.documentElement) {
        const computedStyle = getComputedStyle(document.documentElement);
        setSafeArea({
          top: parseInt(computedStyle.getPropertyValue('--sat') || '0', 10),
          bottom: parseInt(computedStyle.getPropertyValue('--sab') || '0', 10),
          left: parseInt(computedStyle.getPropertyValue('--sal') || '0', 10),
          right: parseInt(computedStyle.getPropertyValue('--sar') || '0', 10)
        });
      }
    };

    updateSafeArea();
    window.addEventListener('resize', updateSafeArea);
    
    return () => {
      window.removeEventListener('resize', updateSafeArea);
    };
  }, []);

  return safeArea;
}
